import { RotateCcw } from 'lucide-react'
import type React from 'react'

import { cn } from '@modules/lib/lib'
import { Button } from '@modules/shadcn/ui/Button/Button'

/** 等倍とみなす誤差。ホイールの刻み（0.1）より十分小さく、浮動小数点の端数だけを吸収する */
const SCALE_EPSILON = 0.001

interface ZoomResetButtonProps {
  /** 現在のズーム倍率（ZoomableImage の onScaleChange で受け取った値） */
  scale: number
  /** 押下時の処理。通常は `transformRef.current?.resetTransform()` */
  onReset: () => void
  className?: string
}

/**
 * キャンバスを等倍・初期位置に戻す「元のサイズに戻す」ボタン（issue #2439）。
 *
 * AIカラー（SimulationDetail）と積算（ElevationPolygonCanvas）で共用する。
 * 等倍のときは押しても何も起きないので描画しない。
 *
 * 配置は呼び出し側で決める（ZoomableImage の中に入れない）。AIカラーは縮小時に外枠の高さを
 * 負マージンで詰めて overflow-hidden で切るため、ZoomableImage 内に絶対配置すると
 * 縮小したとき（＝このボタンが一番必要なとき）に見切れてしまう。
 */
export const ZoomResetButton: React.FC<ZoomResetButtonProps> = ({ scale, onReset, className }) => {
  if (Math.abs(scale - 1) < SCALE_EPSILON) return null
  return (
    <Button
      className={cn('h-7 gap-x-1 bg-background/95 px-2 text-xs shadow-sm', className)}
      onClick={onReset}
      size="sm"
      type="button"
      variant="outline"
    >
      <RotateCcw aria-hidden className="size-3.5" />
      元のサイズに戻す
    </Button>
  )
}
